import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';

import { BreakpointHelperService } from '../../services';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
  ],
  selector: 'customer-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'],
})
export class TemplateComponent {
  @ViewChild('drawer') sidebar?: MatDrawer;
  @ViewChild('rightDrawer') sidebarRight?: MatDrawer;
  @Input() headerTemplate?: TemplateRef<any>;
  @Input() mainHeaderTemplate?: TemplateRef<any>;
  @Input() mainTemplate?: TemplateRef<any>;
  @Input() rightSidebarTemplate?: TemplateRef<any>;
  @Input() sidebarTemplate?: TemplateRef<any>;

  readonly withSidebarOver = ['small', 'x-small'];

  readonly screenType$ = this.breakpointHelperService.screenType$.pipe(
    tap((screenType) => {
      /**
       * Open sidebar if screen type is not in `withSidebarOver` array
       */
      if (!this.withSidebarOver.includes(screenType)) {
        this.sidebar?.open();
      }
    }),
  );

  constructor(private readonly breakpointHelperService: BreakpointHelperService) {
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.toggleSidebarRight = this.toggleSidebarRight.bind(this);
  }

  toggleSidebar() {
    this.sidebar?.toggle();
  }

  toggleSidebarRight() {
    this.sidebarRight?.toggle();
  }
}
